import { useCallback, useEffect, useState } from "react";

/**
 * A one-line status message ("Deal moved to Won.") that clears itself after a few
 * seconds. Problems stay until the next message: `show(text, true)`.
 */
export default function useNotice(ms = 6000) {
  const [notice, setNotice] = useState<{ text: string; sticky: boolean }>({ text: "", sticky: false });
  useEffect(() => {
    if (!notice.text || notice.sticky) return;
    const t = window.setTimeout(() => setNotice({ text: "", sticky: false }), ms);
    return () => window.clearTimeout(t);
  }, [notice, ms]);
  const show = useCallback((text: string, sticky = false) => setNotice({ text, sticky }), []);
  return [notice.text, show] as const;
}
